{
  "lastUpdatedAt": "2026-06-30T19:00:52.158Z",
  "lastFetchAttemptAt": "2026-06-30T19:00:52.158Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}